import { render, staticRenderFns } from "./WisdomParam.vue?vue&type=template&id=8c9f7620&"
import script from "./WisdomParam.vue?vue&type=script&lang=js&"
export * from "./WisdomParam.vue?vue&type=script&lang=js&"
import style0 from "./WisdomParam.vue?vue&type=style&index=0&id=8c9f7620&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports